import {Component, Fragment} from "preact";
import Admin from "../../../../services/admin";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../../utils/money-formatter";
import {FiltersRow, InputFilter} from "../../utils/table-utils";
import {DateHelperFilter, PerPageFilter, TableFormatter} from "../../utils/form-utils";
import PopupLayout from "../site/popup-layout";
// import PopupLayout from "../layout/popup-layout";


export let ManagerTransactionPopup = username => window.open(
    '/admin/transactions/affiliate/'+ encodeURIComponent(username),
    'topupWindow',
    'width=1100,height=600,scrollbars=yes'
);

export class ManagerTransactionHistoryPopup extends Component {
    render() {
        return <PopupLayout>
            <div class="px-0 py-3 bg-white border text-gray-900">
                <div class="py-2 text-lg text-center"><Trans>Storico Movimenti</Trans></div>
                <ManagerTransactionHistory username={this.props.username} />
            </div>
        </PopupLayout>;
    }
}

export class ManagerTransactionHistory extends Component {
    state = {
        dateFilter: {
            helperValue: 0,
            dateStartValue: null,
            dateEndValue: null
        },
        idplayer: null,
        username: null,
        perPage: 10,
        page: 1,
        response: {}
    };

    componentWillMount() {
        this.state.idplayer = !!this.props.idplayer? this.props.idplayer : null;
        this.state.username = !!this.props.username? this.props.username : null;
        this.state.dateFilter.helperValue = 1; // Oggi
        this.state.dateFilter.dateStartValue = new Date().toLocaleDateString('en-CA');
        this.state.dateFilter.dateEndValue = this.state.dateFilter.dateStartValue;
        this.performSearch();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.state.idplayer = !!nextProps.idplayer? nextProps.idplayer : null;
        this.state.username = !!nextProps.username? nextProps.username : null;
    }

    changePage(newpage) {
        //> Controllo di sicurezza per non fare richieste inutili
        if (!!Object.values(this.state.response)) {
            //> Esco se newpage è inferiore a 1 o maggiore del numero massimo di pagine possibili
            if (
                newpage < 1
                || newpage === this.state.page
                || newpage > Math.ceil(this.state.response.totalrecords / this.state.perPage)) {
                return;
            }
        }

        this.state.page = newpage;
        this.performSearch();
    }

    performSearch() {
        Admin.managerTransactions({
            username: this.state.username,
            fromDate: this.state.dateFilter.dateStartValue,
            toDate: this.state.dateFilter.dateEndValue,
            page: this.state.page,
            perPage: this.state.perPage
        })
            .then(response => this.setState({
                response: {
                    totalrecords: response._info.records,
                    recordperpage: this.state.perPage,
                    page: this.state.page,
                    lowlimit: (this.state.page * this.state.perPage) - this.state.perPage,
                    data: response.data
                }
            }));
    }

    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-left body-bg-color"><Trans>Struttura Operante</Trans></strong>,
            <strong class="block text-left body-bg-color"><Trans>Struttura Destinataria</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Data</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Descrizione</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Importo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo Operante</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Fido Operante</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo Destinataria</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Fido Destinataria</Trans></strong>
        ];
    }

    renderUsernameWithIcon(user) {
        let icon = <i class="fa fa-cash-register"/>;
        let username = user.company;

        if (user.idaccess === 100) {
            icon = <i className="fa fa-user main-color"/>;
        }

        if (user.company.indexOf('] ') !== -1) {
            const split = user.company.split(' ');
            username = split[1];

            switch (split[0]) {
                case '[5]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-green-800 font-normal text-center text-[11px]">Sh</span>;
                    break;
                case '[4]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-orange-800 font-normal text-center text-[11px]">A</span>;
                    break;
                case '[3]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-violet-800 font-normal text-center text-[11px]">Sa</span>;
                    break;
                case '[2]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-red-800 font-normal text-center text-[11px]">M</span>;
                    break;
                case '[1]':
                    icon = <span class="inline-block w-4 h-4 font-mono text-white bg-fuchsia-800 font-normal text-center text-[11px]">W</span>;
                    break;
            }
        }

        return <strong class="whitespace-pre">{icon} {username}</strong>;
    }

    tableDataMapper(row) {
        return [
            <span class="block px-2 text-left">{row.idtransazione}</span>,
            <span class="block px-2 text-left">
                {this.renderUsernameWithIcon(row.sender)}
                <span class="block text-xxs betstable-cell-text-color-dark">#{row.sender.idstruttura}</span>
            </span>,
            <span class="block px-2 text-left">
                {this.renderUsernameWithIcon(row.receiver)}
                <span class="block text-xxs betstable-cell-text-color-dark">#{row.receiver.idstruttura}</span>
            </span>,
            <span class="block px-2 text-center">
                {new Date(row.ts * 1000).toLocaleDateString(undefined, {day:'2-digit', month:'2-digit', year:'numeric'})}
                &nbsp;
                {new Date(row.ts * 1000).toLocaleTimeString(undefined, {hour: '2-digit', minute: '2-digit', hourCycle: 'h23'})}
            </span>,
            <span class="block px-2 text-center">{!!row.description.rawmessage? row.description.rawmessage : row.description.message}</span>,
            <span class={'block px-2 text-right '+ (parseFloat(row.amount)<0? 'text-red-600' : 'text-green-600')}><MoneyFormatter value={row.amount} currency={row.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_sender_balance} currency={row.sender.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_sender_fido} currency={row.sender.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_receiver_balance} currency={row.receiver.currency} /></span>,
            <span class="block px-2 text-right"><MoneyFormatter value={row.new_receiver_fido} currency={row.receiver.currency} /></span>
        ];
    }

    render() {
        return <div class="px-3">
            <FiltersRow class="p-2 text-sm items-end justify-center">
                <DateHelperFilter
                    {...this.state.dateFilter}
                    onInput={
                        (dateFilter) => {
                            this.state.dateFilter = dateFilter;
                            this.setState(this.state);
                        }
                    }
                />
                <label class="mx-px px-2">
                    <span class="block text-xs"><Trans>Username</Trans></span>
                    <InputFilter
                        type="text"
                        class="w-40 px-2 py-1 leading-6 rounded border"
                        value={this.state.username}
                        onInput={e => this.setState({username: e.target.value})}
                    />
                </label>
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10,20,30,50,100]}
                    onInput={
                        ({perPage}) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="button p-2 ml-5 main-text-color" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca <i class="fa fa-search" /></Trans>
                </a>
            </FiltersRow>
            <div class="text-xs mt-3">
                <TableFormatter
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    rowClass={'hover:bg-gray-200 border-b'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}